<div>
  <nb-card [nbSpinner]="isLoadingAssessmentsGraphData || isLoadingBiometricHistory">
    <nb-card-body>

      <div class="row">

        <div class="col">
          <div class="groupSubtitle">Biometrics History</div>
        </div>

      </div>

      <!-- Biometric History List -->
      <app-patient-biometric-history-list #biometricHistoryList [patientId]="patientId"
        [patientGuid]="notificationToken" [patientIsPreferredUnitImperial]="patientIsPreferredUnitImperial"
        (edited)="onAssessmentEdited()">
      </app-patient-biometric-history-list>

      <div class="line-graph">
        <chart #chart1 type="line" [data]="bioHistoryGraphData" [options]="bioHistoryGraphOptions"></chart>
      </div>

      <br><br>

      <div class="row">

        <div class="col">
          <div class="groupSubtitle">Weekly CheckIn</div>
        </div>

      </div>

      <!-- Weekly Assessment List -->
      <app-patient-assessment-list [patientId]="patientId" [patientGuid]="notificationToken"
        [patientIsPreferredUnitImperial]="patientIsPreferredUnitImperial">
      </app-patient-assessment-list>

      <div class="line-graph">
        <chart #chart3 type="line" [data]="assessmentSecondGraphData" [options]="assessmentSecondGraphOptions">
        </chart>
      </div>

    </nb-card-body>
  </nb-card>
</div>
